module.exports = __webpack_public_path__ + "img/map2.c530c37.png";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/map2.png
// module id = ./assets/loading/imgs/map2.png
// module chunks = 2 3 4 5 6 7 8